import { FeatureCheckerService, PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Injectable } from '@angular/core';
import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';
import { UserServiceProxy, UserTrackOtherSettingCreateOrEditDto } from '@shared/service-proxies/service-proxies';

@Injectable()
export class AppNavigationService {
    constructor(
        private _permissionCheckerService: PermissionCheckerService,
        private _appSessionService: AppSessionService,
        private _userServiceProxy: UserServiceProxy,private _featureCheckerService:FeatureCheckerService
    ) {
    }
    getMenu(): AppMenu {
        return new AppMenu("MainMenu", "MainMenu", [
            new AppMenuItem("Dashboard", "Pages.Administration.Host.Dashboard", "icon-dash", "/app/admin/hostDashboard"),
            new AppMenuItem("Dashboard", "Pages.Tenant.Dashboard", "icon-dash", "/app/main/dashboard", undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.DashBoardInEdition');}),
            /*            new AppMenuItem('xyz', null, 'icon-dash', '/app/shared/intime-dashboard/intime-dashboard'),

             */ new AppMenuItem("Tenants", "Pages.Tenants", "flaticon-list-3", "/app/admin/tenants"),

            new AppMenuItem("Editions", "Pages.Editions", "flaticon-app", "/app/admin/editions"),

            new AppMenuItem("Trial Request", "Pages.Tenants", "flaticon-list-3", "/app/admin/TrialTenant"),
            // new AppMenuItem("Clients", "Pages.Clients", "icon-client", "/app/main/client/client-managment"),
            new AppMenuItem("Clients", "Pages.Clients", "icon-client", "/app/main/client-new", undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.ClientEdition');}),
            //new AppMenuItem('Product', null, 'icon-project', '/app/main/product-service'),
            /*new AppMenuItem("Projects", null, "icon-project", "/app/main/project/project-management"),*/
            new AppMenuItem("Projects", "Pages.Projects", "icon-project", "/app/main/projects-new", undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.ProjectInEdition');}),
            new AppMenuItem("Leaves", "Pages.TimeOff", "icon-Calendar", "/app/main/Leaves/overview", undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.TimeOffEdition');}),

            new AppMenuItem(
                "Activities",
                "",
                "icon-activities",
                "",
                [],
                [
                    new AppMenuItem(
                        "RealTimeTracking",
                        "Pages.Activity.ReamTimeTracking",
                        "icon-Real-Time-Tracking",
                        "/app/main/activities/real-time-tracking"
                        , undefined, undefined, undefined,undefined, () => {
                            return this._featureCheckerService.isEnabled('App.RealTimeTracking');}),
                    new AppMenuItem("Time and Attendance", "Pages.Activity.TimeAndAttendence", "icon-Time-Attendance", "/app/main/activities/time-and-attendance", undefined, undefined, undefined,undefined, () => {
                        return this._featureCheckerService.isEnabled('App.Timeandattendence');}),
                    new AppMenuItem("Apps and Websites", "Pages.Activity.AppAndWebSites", "icon-Apps-Websites", "/app/main/activities/apps-and-websites", undefined, undefined, undefined,undefined, () => {
                        return this._featureCheckerService.isEnabled('App.AppAndWebsite');}),
                    new AppMenuItem("Screenshots", "Pages.Activity.ScreenShots", "icon-Screenshots", "/app/main/activities/screenshots", undefined, undefined, undefined,undefined, () => {
                        return this._featureCheckerService.isEnabled('App.Screenshot');}),
                    new AppMenuItem("Live Streaming", "Pages.Activity.liveStreaming.View", "icon-live-streaming", "/app/main/activities/live-screenshots", undefined, undefined, undefined,undefined, () => {
                        return this._featureCheckerService.isEnabled('App.LiveStreaming');}),

                ]
            , undefined, undefined, () => {
                    return this._featureCheckerService.isEnabled('App.ActivitiesEdition');}),
            // new AppMenuItem('Activities (prior)', '', 'icon-activities', '', [], [
            //     new AppMenuItem('Real Time Tracking', 'Pages.Activity.ReamTimeTracking', 'icon-TimeTrack', '/app/main/realTimeTracking'),
            //     new AppMenuItem('Time and Attendance', null, 'flaticon-map', '/app/main/timAndAttendance'),
            //     new AppMenuItem('Apps and Websites', null, 'flaticon-map', '/app/main/appActivity'),
            //     new AppMenuItem('Screenshots', null, 'flaticon-map', '/app/main/activityScreenshot'),
            // ]),
            //new AppMenuItem('Calendar', null, 'icon-Calendar', '/app/main/calendar/calendar-managment'),
            new AppMenuItem("TimeTracking", "Pages.TimeSheet", "icon-TimeTrack", "/app/main/time-tracking/time-tracking", undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.TimeTrackingEdition');}),
         /*   new AppMenuItem("Timesheet", "Pages.TimeSheet", "icon-TimeSheet", "/app/main/time-sheet/time-sheet-management", undefined, undefined, undefined,undefined, () => {
                return this._featureCheckerService.isEnabled('App.TimeSheetEdition');}),*/
                 new AppMenuItem("Timesheet", "Pages.TimeSheet", "icon-TimeSheet", "/app/main/time-sheet-new/time-sheet-management-new", undefined, undefined, undefined, undefined, () => {
                return this._featureCheckerService.isEnabled('App.TimeSheetEdition');
            }),

            //  new AppMenuItem("Invoice", "Pages.Invoice", "icon-invoice", "/app/main/invoice-list/invoice-managment"),
            // new AppMenuItem("Outlook", "", "icon-Calendar", "/app/main/new-outlook-calendar/calendar"),

             new AppMenuItem("Reports", "Pages.Reports", "icon-reports", "/app/main/reports"
             , undefined, undefined, undefined,undefined, () => {
               return this._featureCheckerService.isEnabled('App.ReportEdition');}),
            new AppMenuItem('Subscription', 'Pages.Administration.Tenant.SubscriptionManagement', 'flaticon-refresh', '/app/admin/subscription-management'),
            //new AppMenuItem('Shared Components', '', 'icon-invoice', '/app/main/demo/shared-components'),
            new AppMenuItem(
                "Administration",
                "Pages.Administration",
                "icon-admin1",


                "",
                [],
                [
                    /*new AppMenuItem('OrganizationUnits', 'Pages.Administration.OrganizationUnits', 'flaticon-map', '/app/admin/organization-units'),*/
                    new AppMenuItem("Roles", "Pages.Administration.Roles", "icon-admin-roles", "/app/admin/roles"),
                    // new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
                    new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', '/app/admin/languages'),
                    new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', '/app/admin/auditLogs'),
                    new AppMenuItem('Maintenance', 'Pages.Administration.Host.Maintenance', 'flaticon-lock', '/app/admin/maintenance'),
                   // new AppMenuItem('Subscription', 'Pages.Administration.Tenant.SubscriptionManagement', 'flaticon-refresh', '/app/admin/subscription-management'),
                    new AppMenuItem('VisualSettings', 'Pages.Administration.UiCustomization', 'flaticon-medical', '/app/admin/ui-customization'),
                    new AppMenuItem('WebhookSubscriptions', 'Pages.Administration.WebhookSubscription', 'flaticon2-world', '/app/admin/webhook-subscriptions'),
                    new AppMenuItem('DynamicProperties', 'Pages.Administration.DynamicProperties', 'flaticon-interface-8', '/app/admin/dynamic-property'),
                    new AppMenuItem('Settings', 'Pages.Administration.Host.Settings', 'flaticon-settings', '/app/admin/hostSettings'),
                    //new AppMenuItem('Settings', 'Pages.Administration.Tenant.Settings', 'flaticon-settings', '/app/admin/tenantSettings')
                ]
            ),
            new AppMenuItem('ProxyLogin', 'Pages_SuperAdmin.Impersonate.user', 'icon-superadmin', '/app/admin/Superadmin')
            //new AppMenuItem('DemoUiComponents', 'Pages.DemoUiComponents', 'icon-demiui', '/app/admin/demo-ui-components')
        ]);
    }

    checkChildMenuItemPermission(menuItem): boolean {
      // console.log(this._featureCheckerService.isEnabled('App.Screenshot'));
       //console.log(this._featureCheckerService.isEnabled('App.ReportEdition'));
        for (let i = 0; i < menuItem.items.length; i++) {
            let subMenuItem = menuItem.items[i];

            if (subMenuItem.permissionName === "" || subMenuItem.permissionName === null) {
                if (subMenuItem.route) {
                    return true;
                }
            } else if (this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
                return true;
            }

            if (subMenuItem.items && subMenuItem.items.length) {
                let isAnyChildItemActive = this.checkChildMenuItemPermission(subMenuItem);
                if (isAnyChildItemActive) {
                    return true;
                }
            }
        }
        return false;
    }

    showMenuItem(menuItem: AppMenuItem): boolean {
        if (
            menuItem.permissionName === "Pages.Administration.Tenant.SubscriptionManagement" &&
            this._appSessionService.tenant &&
            !this._appSessionService.tenant.edition
        ) {
            return false;
        }

        let hideMenuItem = false;

        if (menuItem.requiresAuthentication && !this._appSessionService.user) {
            hideMenuItem = true;
        }

        if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
            hideMenuItem = true;
        }

        if (this._appSessionService.tenant || !abp.multiTenancy.ignoreFeatureCheckForHostUsers) {
            if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
                hideMenuItem = true;
            }
        }

        if (!hideMenuItem && menuItem.items && menuItem.items.length) {
            return this.checkChildMenuItemPermission(menuItem);
        }

        return !hideMenuItem;
    }

    /**
     * Returns all menu items recursively
     */
    getAllMenuItems(): AppMenuItem[] {
        let menu = this.getMenu();
        let allMenuItems: AppMenuItem[] = [];
        menu.items.forEach((menuItem) => {
            allMenuItems = allMenuItems.concat(this.getAllMenuItemsRecursive(menuItem));
        });

        return allMenuItems;
    }

    private getAllMenuItemsRecursive(menuItem: AppMenuItem): AppMenuItem[] {
        if (!menuItem.items) {
            return [menuItem];
        }

        let menuItems = [menuItem];
        menuItem.items.forEach((subMenu) => {
            menuItems = menuItems.concat(this.getAllMenuItemsRecursive(subMenu));
        });

        return menuItems;
    }



}
